import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import papaparse from 'papaparse'
import * as moment from 'moment';
import _ from 'lodash'

import { Utils } from '../../shared/static/utils';
import { UserModel } from '../../shared/model/user.model';
import { RequestModel } from '../../shared/interface/response';
import { HeaderItemModel } from '../../shared/model/header-item.model';
import { MessageComponent } from '../../shared/component/message/message.component';
import { ChecklistAnsweredModel } from '../../shared/model/checklist-answered.model';
import { AnalisyStatusTranslation, ConclusionTypes } from '../../shared/enum/conclusion-type';
import { ChecklistResponseQueryComponent } from '../../shared/component/checklist-response-filter-query/checklist-response-filter-query.component';

@Component({
	selector: 'app-checklist-answered',
	templateUrl: './checklist-answered.component.html',
	styleUrls: ['./checklist-answered.component.css'],
})
export class ChecklistAnsweredComponent extends ChecklistResponseQueryComponent implements AfterViewInit {
	@ViewChild(MessageComponent) message: MessageComponent;

	formatNumber = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 });

	responses = [];
	withDescription: boolean = false;

	totalRecords: number;
	unconformities_total: number;
	unconformities: any[];
	unconformities_check: any = false;
	withUserObservation = true;
	isGrouped = false
	unconformities_list_grouped: any[]
	unconformities_list;
	initial_unconformities;
	unconformities_list_by_question;
	grouped_by_question = false;
	unconformities_total_quantity = 0
	quantities_total_quantity = 0
	quantities_list
	quantities_list_grouped
	quantities
	initial_quantities
	quantities_check: any = false
	isQuantitiesGrouped = false
	quantities_total = 0
	showlist

	loading: boolean;

	// UNUSED PROPS
	headerItemFilters: any[] = [];
	headerItemsView: HeaderItemModel[] = [];

	// Customization
	layoutKeys: string[] = [];
	layoutKeysCache = {};

	// From another component
	rawUsers: UserModel[] = [];

	ngAfterViewInit() {
		this.analisyStatus = 0;
		this.customizationHandle();
	}

	customizationHandle(override?) {
		const customKeys = JSON.parse(localStorage.getItem('check_resp_cust'));

		if (!customKeys || !this.layoutKeys || customKeys == 'null') {
			this.layoutKeys = this.getDefaultCheckRespKeys();

			override = true;
		} else if (!override) {
			this.layoutKeys = customKeys;

			override = true;
		}

		this.resetLayoutKeysCache();

		if (override)
		localStorage.setItem('check_resp_cust', JSON.stringify(this.layoutKeys));
	}

	// Optimization for HTML rendering
	resetLayoutKeysCache() {
		// Reseting cache keys to false
		Object.getOwnPropertyNames(this.layoutKeysCache).forEach(k => {
			this.layoutKeysCache[k] = false;
		});

		// Updating the enabled keys
		this.layoutKeys.forEach(k => {
			this.layoutKeysCache[k] = true;
		})
	}

	getIcon = (row) => `ui-icon-${row.approved ? 'check' : 'close'} ui-button-icon-left fa fa-fw ui-icon-library-${row.approved ? 'check' : 'close'}`

	validateChecklistStatus(response) {
		if (!response.checklist || !response.checklist.conclusion_type) {
			return console.error('Error na resposta');
		}

		let result = false;

		switch(response.checklist.conclusion_type) {
			case ConclusionTypes['Por Análise']:
				result = true;
				break;
			case ConclusionTypes['Por Aprovação']:
				result = true;
				break;
			default: 
				result = false;
		}

		return result;
	}

	changeTab(event) {
		const target = event && event.target && event.target.outerHTML;
		const validation = JSON.stringify(target || '');

		const isInvalid1 = validation.includes('ui-unselectable-text');
		const isInvalid2 = validation.includes('ui-tabview-panel');
		const isTableLine = validation.includes('ui-cell-data');
		const isPaginator = validation.includes('paginator');
		const isTableList = validation.includes('tablist');
		const isTableBtn = validation.includes('button');

		if (!isPaginator && !isTableLine && !isTableList && !isTableBtn && !isInvalid1 && !isInvalid2) {
			if (this.analisyStatus) {
				this.analisyStatus = 0;
			} else if (!isTableBtn && !isTableLine) {
				this.analisyStatus = AnalisyStatusTranslation['send_to_analisy'];
			}
		}
	}

	deleteResponse(response) {
		if (response && response.id)
		this.reportService.deleteResponse(response.id).pipe(take(1)).subscribe((res: number) => {
			if (res) {
				this.filter(this.queryData);
				this.message.success('answer_deleted_successfully');
			} else {
				this.message.error('status_error');
			}
		});
	};

	resendEmail(response) {
		if (response && response.id)
		this.reportService.resendEmail(response.id).pipe(take(1)).subscribe((res: number[]) => {
			if (res && res.length) {
				this.filter(this.queryData);
				this.message.success('updated');
			} else {
				this.message.error('status_error');
			}
		});
	};

	changeList() {
		if (this.unconformities_check || this.grouped_by_question) {
			this.isGrouped = true
			if (this.unconformities_check)
				this.unconformities = this.unconformities_list_grouped
			else
				this.unconformities = this.unconformities_list_by_question

		}
		else {
			this.isGrouped = false
			this.unconformities = this.unconformities_list
		}
		if (this.quantities_check) {
			this.isQuantitiesGrouped = true
			this.quantities = this.quantities_list_grouped
		}
		else {
			this.isQuantitiesGrouped = false
			this.quantities = this.quantities_list
		}
	}

	findHeaderItemPrimary = (row, primary = true) => {
		let target = this.responses.find(response => response.id == row.id);
		let responseItems = target ? target.header_response_items : null;
		let result = 'N/A';

		// if (!this.listValues.length || !this.lists.length) this.loadLists();

		if (responseItems && responseItems.length > 0 && this.listValues && this.listValues.length > 0) {
			let items = responseItems.filter(resItem => resItem.header_item ? resItem.header_item.primary == primary : false);

			if (items.length && this.lists.length && this.listValues.length) {

				let names = items.map((item) => {
					const { response, header_item, list_value_id } = item;
					let result = '';

					if (header_item && header_item.list_id) {
						const targetId = list_value_id || parseInt(response);
						const listValue = this.listValues.find((value) => value.id == targetId);
						const isList = listValue && listValue.description;

						result = response;
						if (isList && !list_value_id)
						result = listValue.description;
						else if (isList && list_value_id)
						header_item.description = listValue.description;

					}	else result = response;

					return this.withDescription ? ` ${header_item.description}: ${result}` : result;
				});

				result = names;
			}
		}

		return result;
	};

	exportUnconformities() {
		let element = document.createElement('a');

		element.setAttribute('href', 'data:application/octet-stream;charset=utf-8,' + encodeURIComponent(
			papaparse.unparse(
			this.initial_unconformities.map(({ quantity, response, description, unconformity, name, user_observation }) => {
				return {
					[this.translate('group') || 'Grupo']: name, 
					[this.translate('question') || 'Questão']: description, 
					[this.translate('quantity') || 'Quantidade']: quantity,
					[this.translate('unconformity') || 'Não conformidade']: unconformity,
					[this.translate('response') || 'Resposta']: response || '',
					[this.translate('observation') || 'Observação']: user_observation || '',
				}
			}), { delimiter: ";" }))
		);

		const now = '_' + new Date().toLocaleString();
		element.setAttribute('download', this.translate('report') + now + '.csv');

		element.style.display = 'none';
		document.body.appendChild(element);

		element.click();

		document.body.removeChild(element);
	}

	// Not required
	exportQuantities() {
		let element = document.createElement('a');

		element.setAttribute('href', 'data:application/octet-stream;charset=utf-8,' + encodeURIComponent(papaparse.unparse(
			this.initial_quantities.map(({ quantity, description, name }) => {
				return {
					[this.translate('group') || 'Grupo']: name,
					[this.translate('question') || 'Questão']: description,
					[this.translate('quantity') || 'Quantidade']: quantity,
				}
			}), { delimiter: ";" }))
		);
		
		const now = '_' + new Date().toLocaleString();
		element.setAttribute('download', this.translate('quantity') + '_' + this.translate('report') + now + '.csv');

		element.style.display = 'none';
		document.body.appendChild(element);

		element.click();

		document.body.removeChild(element);
	}

	filter(newEvent) {
		this.responses = [];

		this.queryData = this.updateFilterData(newEvent, this.queryData);

		// REQUESTED BY CUSTOMER, USING TAB VIEW NOW
		this.queryData.analisy_status = this.analisyStatus;

		// disabling lazy loading without filter params
		if (this.needWaitForFilter()) return;

		// changing/updating local var state
		this.withDescription = this.queryData.with_description || false;
		this.user = this.queryData.user || this.user || null;

		this.rawUsers = this.queryData.raw_users() || [];
		// this.queryData.raw_users = [];

		if (!this.loading) {
			this.loading = true;

			this.reportService.getChecklistsAnsweredComplete(this.queryData)
      .pipe(take(1)).finally(() => this.loading = false )
			.subscribe((response: RequestModel<any[]>) => {
				this.message.success(this.translate('loaded_data'));

				const { count, rows } = response;

				this.totalRecords = count;
				this.responses = rows;

				let { checklistIds, checklist_response_ids } = rows.reduce((acc: any, crr) => {
					if (!acc.checklistIds.includes(crr.checklist_id))
						acc.checklistIds.push(crr.checklist_id)

						if (!acc.checklist_response_ids.includes(crr.id))
							acc.checklist_response_ids.push(crr.id)
						return acc
					},{
						checklist_response_ids: [],
						checklistIds: []
				})

				this.reportService.getUnconformities(this.queryData.init, this.queryData.end, checklistIds, moment(this.init_date).format(), moment(this.end_date).endOf('day').format(), this.checklist.origin_id, checklist_response_ids, this.withUserObservation).subscribe((res) => {

					let groupedByName = _.groupBy(_.orderBy(res.rows, 'quantity', 'desc'), 'name'),
						groupedByDescription = _.groupBy(_.orderBy(res.rows, 'quantity', 'desc'), 'description')
					this.unconformities_total = res.count
					this.unconformities_total_quantity = _.sumBy(res.rows, 'quantity')
					this.initial_unconformities = res.rows
					this.unconformities_list_grouped = _.orderBy(Object.keys(groupedByName).map((key) => {

						let groupedByUnconformity = _.groupBy(groupedByName[key], 'unconformity'),

							items = _.orderBy(Object.keys(groupedByUnconformity).map((itemKey) => {

								return { quantity: _.sumBy(groupedByUnconformity[itemKey], 'quantity'), unconformity: itemKey }

							}), 'quantity', 'desc')

						return { name: key, items: items, quantity: _.sumBy(items, 'quantity') }

					}), 'quantity', 'desc')

					let groupedByUnconformity = _.groupBy(res.rows, 'unconformity')

					this.unconformities_list = _.orderBy(Object.keys(groupedByUnconformity).map((itemKey) => {
						const criticality = 
						groupedByUnconformity[itemKey][0] && groupedByUnconformity[itemKey][0]['criticality']
						groupedByUnconformity[itemKey][1] && groupedByUnconformity[itemKey][1]['criticality'] || 9;

						return { quantity: _.sumBy(groupedByUnconformity[itemKey], 'quantity'), unconformity: itemKey, criticality }

					}), 'quantity', 'desc')
					// this.unconformities_list = _.orderBy(_.groupBy(res.rows, 'unconformity'), 'quantity', 'desc')

					this.unconformities_list_by_question = _.orderBy(Object.keys(groupedByDescription).map((key) => {

						let groupedByUnconformity = _.groupBy(groupedByDescription[key], 'unconformity'),

							items = Object.keys(groupedByUnconformity).map((itemKey) => {

								return { quantity: _.sumBy(groupedByUnconformity[itemKey], 'quantity'), unconformity: itemKey }

							})

						return { description: key, items: items, quantity: _.sumBy(groupedByDescription[key], 'quantity') }

					}), 'quantity', 'desc')


					if (this.isGrouped)
						this.unconformities = this.unconformities_list_grouped
					else
						this.unconformities = this.unconformities_list

					this.reportService.getQuantities(this.queryData.init, this.queryData.end, checklistIds, moment(this.init_date).format(), moment(this.end_date).endOf('day').format(), this.checklist.origin_id, checklist_response_ids).subscribe((res) => {
						let groupedByName = _.groupBy(_.orderBy(res.rows, 'quantity', 'desc'), 'name')
						this.quantities_total = res.count
						this.initial_quantities = res.rows
						this.quantities_total_quantity = _.sumBy(res.rows, 'quantity')
						this.quantities_list_grouped = _.orderBy(Object.keys(groupedByName).map((key: any) => {
							return { name: key, items: groupedByName[key], quantity: _.sumBy(groupedByName[key], 'quantity') }
						}))
						// console.log(this.quantities_list_grouped)
						this.quantities_list = _.orderBy(res.rows, 'quantity', 'desc');

						if (this.isQuantitiesGrouped)
							this.quantities = this.quantities_list_grouped;
						else
							this.quantities = this.quantities_list;

						this.loading = false;
					})
				})
			}, ({ error }) => this.errorHandler(error));
		}
	}

	getUserName(id: number) {
		const exists = id && this.rawUsers.length && this.rawUsers.find(u => u.id == id);
		return exists && exists.name || 'N/A';
	}

	needWaitForFilter = () => !(this.queryData && this.queryData.init_date);

	translate = (key: string) => this.translateService.instant(key || "invalid");

	getDefaultCheckRespKeys = () => Utils.checkRespKeys(
		{
			model: new ChecklistAnsweredModel(),
			includes: ['main_header_response', 'status'],
			excludes: ['user_id', 'orders'],
		},
	);
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/report/checklist-answered/checklist-answered.component.ts